export default "__VITE_ASSET__CIsbZJOv__"